import React, { PureComponent } from 'react';
import LawyerFormField from './LawyerFormField';
import { allLawyers } from '../../../queries/AllLawyers';
import { compose, graphql } from 'react-apollo';
import _ from 'lodash';
import withEligibleCountriesOptions from '../../HOC/withEligibleCountriesOptions';

const NEB = [
  {
    text: 'NEB',
    value: '0',
    lawFirm: 'Not Assigned',
    key: '0'
  }
];

class LawyerFormFieldContainer extends PureComponent {
  componentDidUpdate = prevProps => {
    const { lawyers, onChange, litigationCountry, lawyer } = this.props;
    const prevLawyers = prevProps.lawyers();
    const allLawyers = lawyers();
    if (!prevLawyers) {
      return;
    }
    if (!lawyer || !allLawyers[0] || litigationCountry === 'other') {
      return onChange(undefined, { name: 'lawyer', value: NEB[0].value });
    }
    if (_.get(prevLawyers, '[0].value') !== _.get(allLawyers, '[0].value')) {
      return onChange(undefined, {
        name: 'lawyer',
        value: allLawyers[0].value
      });
    }
  };

  render() {
    const { lawyers, eligibleCountriesOptions } = this.props;
    const allLawyers = lawyers() || [];
    const areLawyerOptions = allLawyers.length > 0;

    const lawyerOptions = areLawyerOptions ? allLawyers : NEB;
    return (
      <LawyerFormField
        {...this.props}
        lawyers={lawyerOptions}
        countries={eligibleCountriesOptions}
      />
    );
  }
}

export default compose(
  withEligibleCountriesOptions,
  graphql(allLawyers, {
    options: ({ litigationCountry }) => ({
      variables: {
        litigationCountries: [litigationCountry]
      }
    }),
    props: ({ data }) => ({
      lawyers: () => {
        const lawyers = _.get(data, 'allLawyers');
        const undefinedLabel = 'Not Assigned';
        if (!lawyers) {
          return null;
        }
        return lawyers.map(({ id, name, lawFirm }) => ({
          key: id,
          text: name,
          value: id,
          lawFirm: _.get(lawFirm, 'name', undefinedLabel)
        }));
      }
    })
  })
)(LawyerFormFieldContainer);



// WEBPACK FOOTER //
// ./src/component/FormFields/LawyerFormField/index.js